import React from 'react';
import ReactHighcharts from 'react-highcharts';
// import Divider from 'material-ui/Divider';
import {withStyles} from 'material-ui/styles';

const styles = () => ({});

class ChartAnalytics extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    static getConfigColumn = (title, data) => ({
        credits: {
            enabled: false
        },
        chart: {
            type: 'column'
        },
        xAxis: {
            categories: data.dates
        },
        title: {
            text: title
        },
        tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormat: '{series.name}: {point.y} ' + '({point.percentage:.1f}%)',
        },
        yAxis: {
            min: 0,
            title: {
                text: ''
            },
            stackLabels: {
                enabled: true,
                style: {
                    fontWeight: 'bold',
                }
            }
        },
        series: data.data,
        plotOptions: {
            column: {
                stacking: 'normal',
                dataLabels: {
                    enabled: false,
                }
            }
        },
    });

    componentDidMount() {
        const _this = this;
        console.log('chart componentDidMount', _this.props);
    }

    render() {
        const _this = this;
        return (
            <ReactHighcharts
                config={ChartAnalytics.getConfigColumn(_this.props.title, _this.props.data)}/>
        );
    }
}

export default withStyles(styles)(ChartAnalytics);


// WEBPACK FOOTER //
// ./src/components/tabs/analytics/ChartAnalytics.js